import React from 'react';
import {Feed} from "semantic-ui-react";
import avatarPlaceholder from "../assets/avatar_placeholder.jpg";
import {accountText} from "./WinnerItem";

const WinnersFeed = ({ winners = [] }) => {
	return (
		<Feed size="large">
			{winners.map(({ profile_pic_url = '', full_name = '', username = '', source }) => (
				<Feed.Event key={username}>
					<Feed.Label image={{
						style: { height: '2.5em' },
						src: profile_pic_url,
						onError: e => e.target.src = avatarPlaceholder
					}} />
					<Feed.Content>
						<Feed.Date content={accountText(source, username)} />
						<Feed.Summary content={full_name} />
					</Feed.Content>
				</Feed.Event>
			))}
		</Feed>
	)
}

export default WinnersFeed;
